import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from 'react-toastify'


const initialOptions = {
  "client-id": "YOUR_PAYPAL_CLIENT_ID",
  "enable-funding": "subscription",
  "vault": true, // Required for subscriptions
};

const SubscribeButton = () => {
  const handleSubscription = async (data, actions) => {
    return actions.subscription
      .create({
        plan_id: "YOUR_PAYPAL_PLAN_ID", // Replace with your PayPal plan ID
      })
      .then(async (subscriptionId) => {
        console.log("Subscription ID:", subscriptionId);

        const token = localStorage.getItem("token");

        // Send Subscription ID to backend
        const response = await fetch("/api/subscribe", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
          throw new Error("Failed to save subscription");
        }

        toast.success("Subscription successful!");
      });
  };

  return (
    <PayPalScriptProvider options={initialOptions}>
      <PayPalButtons
        style={{ layout: "vertical" }}
        createSubscription={handleSubscription}
      />
    </PayPalScriptProvider>
  );
};

export default SubscribeButton;
